export default { 
    name: "functions",
    methods: {
      // // Get Exhibition Title and Subtitle
      // getSelf: function () {
      //   if (!this.$global.exhibition) {
      //     return axios({ method: "GET", "url": `${process.env.VUE_APP_EXHIBITION_ENDPOINT}/thg/galleries/self` }).then(result => {
      //       this.$global.exhibition = result.data;
      //       let links = this.$global.exhibition.links;
      //       for (let i = 0; i < links.length; i++) {
      //         if (links[i].rel === "themes") {
      //           this.$global.themesURL = links[i].href;
      //           break;
      //         }
      //       }
      //       // this.$global.colors = {
      //       //   mainColor: "blue",
      //       //   mainTextColor: "pink",
      //       //   secondaryColor: "red",
      //       //   secondaryTextColor: "gray",
      //       //   contrastColor: "purple",
      //       //   contrastTextColor: "green"
      //       // }
      //     }, error => {
      //         console.error(error);
      //     });
      //   } else {
      //     return this.$global.exhibition;
      //   }
      // },
      // Removes extra spaces/periods
      audit: function(object) {
        for (let field in object) {
          let string = object[field];
          if (typeof string !== "string") {
            continue;
          } else if (string && string.slice(-1) === "." ||
            string && string.slice(-1) === " ") {
            string = string.substring(0, string.length - 1);
            if (string.slice(-1) === "." || string.slice(-1) === " ") {
              string = string.substring(0, string.length - 1);
            }
            object[field] = string;
          }
        }
      },
      // Truncates description text and adds "..."
      truncate: function(chars, text) {
        if (text) {
          if (text.length <= chars) {
            return text;
          } else {
            let space = " ";
            let slice = text.substring(0, text.lastIndexOf(space, chars));
            slice = slice + "...";
            return slice;
          }
        }
      },
      // Get the href for a matching rel (when no object name)
      getRelLink: (array, rel) => {
        for (let i = 0; i < array.length; i++) {
          if (array[i].rel === rel) {
            return array[i].href;
          }
        }
      },
      // https://stackoverflow.com/a/32851198
      convertToRoman: function(number) {
        let lookup = { M: 1000, CM: 900, D: 500, CD: 400, C: 100, XC: 90, L: 50, XL: 40, X: 10, IX: 9, V: 5, IV: 4, I: 1 }, roman = "", i;
        for (i in lookup) {
          while (number >= lookup[i]) {
            roman += i;
            number -= lookup[i];
          }
        }
        return roman;
      },
      // Sort items chronologically by startDate key
      sortChronological: function(items) {
        let sorted = Object.values(items).sort(function (a, b) {
          return a.startDate - b.startDate;
        });
        let dateTruncated = sorted;
        for (let key in dateTruncated) {
          let date = dateTruncated[key].objectDate;
          if (this.charactersOver80(date)) {
            dateTruncated[key].objectDate = this.cutOff(date);
          }
        }
        // Remove duplicate item entries by name of item
        // https://stackoverflow.com/a/64791605
        let removeDupes = dateTruncated;
        let names = removeDupes.map(({ name }) => name);
        let removed = removeDupes.filter(({ name }, index) => !names.includes(name, index + 1));
        return removed;
      },
      charactersOver80: function(text) {
        if (!text) {
          return false;
        } else if (text.length > 80) {
          return true;
        } else {
          return false;
        }
      },
      cutOff: function(text) {
        let slice = text.slice(0, 79);
        slice = slice + "[...]";
        return slice;
      },
      getBannerInfo: function() {
        return axios({ method: "GET", "url": this.objectURL }).then(result => {
          this.objectInfo = result.data;
          this.objectInfoLoaded = true;
        }, error => {
          console.error(error);
        });
      },
    }
  }